import moment from "moment";
import React from "react";
import Calendar from "react-input-calendar";
import DaysView from "./DaysView";
import MonthsView from "react-input-calendar/dist/month-view";
import YearsView from "react-input-calendar/dist/year-view";
import * as Icons from "../../../constants/SvgIcons";
import styles from "./DatePicker.module.less";
import classNames from "classnames";
import { FormattedMessage } from "react-intl";
class tCombCalendar extends Calendar {
    constructor(props) {
        super(props);
        this._handleBlur = this._handleBlur.bind(this);
        this._handleFocus = this._handleFocus.bind(this);
        this._handleChange = this._handleChange.bind(this);
    }
    /* --- React Lifecycle Methods --- */
    /**
     * React lifecycle method
     *
     * @method render
     * @private
     * @returns {HTMLElement} Component element
     */
    render() {
        let calendar;
        let calendarIcon;
        let view;
        let readOnly = false;
        const props = this.props;
        const state = this.state;
        // its ok for this.state.date to be null, but we should never
        // pass null for the date into the calendar pop up, as we want
        // it to just start on todays date if there is no date set
        const calendarDate = state.date || moment();
        const viewProps = {
            date: calendarDate,
            nextView: this.nextView,
            prevView: this.prevView,
            maxDate: state.maxDate,
            minDate: state.minDate,
            setInputDate: this.setInputDate,
            setInternalDate: this.setInternalDate
        };
        /* Set view settings */
        switch (state.currentView) {
            case 1:
                view = (<MonthsView {...viewProps}/>);
                break;
            case 2:
                view = (<YearsView {...viewProps}/>);
                break;
            default:
                view = (<DaysView {...viewProps} isDayDisabled={props.isDayDisabled}/>);
                break;
        }
        /* Set calendar template */
        if (!state.isVisible || this.props.disabled) {
            calendar = "";
        }
        else {
            calendar = (<div className={`input-calendar-wrapper ${styles.wrapper}`} onClick={this.calendarClick}>
					{view}
					<span className={`today-btn${this.checkIfDateDisabled(moment().startOf("day")) ?
                " disabled" :
                ""}`} onClick={this.todayClick}>
						Today
					</span>
				</div>);
        }
        /* hideTouchKeyboard settings */
        if (props.hideTouchKeyboard) {
            // do not break server side rendering:
            try {
                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
                    .test(navigator.userAgent)) {
                    readOnly = true;
                }
            }
            catch (e) {
                console.warn(e);
            }
        }
        /* Icon settings */
        if (props.hideIcon || this.props.disabled) {
            calendarIcon = "";
        }
        else {
            calendarIcon = (<button type="button" className="icon-wrapper calendar-icon" onClick={this.toggleClick}>
					<svg width="16" height="18" viewBox="0 0 100 111.1">
						{Icons.ICONS.EVENT}
					</svg>
					<span className="u-isVisuallyHidden">
						<FormattedMessage id="datePicker.toggle" defaultMessage="Toggle calendar"/>
					</span>
				</button>);
        }
        const inputProps = this.props.inputProps || {};
        return (<div className="input-calendar">
				<input ref="input" // tslint:disable-line:jsx-no-string-ref
         type="text" aria-invalid={props.invalid ? "true" : undefined} {...inputProps} id={props.inputFieldId || inputProps.id} className={classNames("input-calendar-field", inputProps.className, props.inputFieldClass)} disabled={props.disabled || inputProps.disabled} name={props.inputName || inputProps.name} readOnly={readOnly || inputProps.readOnly} placeholder={props.placeholder || inputProps.placeholder} value={state.inputValue || ""} required={props.required || inputProps.required ? true : undefined} onBlur={this._handleBlur} onFocus={this._handleFocus} onChange={this._handleChange}/>
				{calendarIcon}
				{calendar}
			</div>);
    }
    _handleBlur(event) {
        const { inputProps } = this.props;
        if (inputProps != null && inputProps.onBlur != null) {
            inputProps.onBlur(event);
        }
        this.inputBlur(event);
    }
    _handleFocus(event) {
        const { inputProps } = this.props;
        if (inputProps != null && inputProps.onFocus != null) {
            inputProps.onFocus(event);
        }
        this.inputFocus(event);
    }
    _handleChange(event) {
        const { inputProps } = this.props;
        if (inputProps != null && inputProps.onChange != null) {
            inputProps.onChange(event);
        }
        this.changeDate(event);
    }
}
export default tCombCalendar;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/presentational/DatePicker/DatePicker.tsx